module.exports = __webpack_public_path__ + "img/galeria2.40bc1031.jpg";